var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"fade"}},[_c('div',[_c('Slider',{attrs:{"animation":"fade","duration":5000,"speed":2000}},_vm._l((_vm.slides),function(i,index){return _c('SliderItem',{key:index,style:(i)})}),1)],1)])}
var staticRenderFns = []

export { render, staticRenderFns }